import React from 'react';
import { Link } from 'react-router-dom';
import { ProgressBar, Step } from "react-step-progress-bar";

const PostTask = (props) => {

    const { page, onPageNumberClick } = props;

    var stepPercentage = 0;
    if (page === "pageone") {
        stepPercentage = 0;
    } else if (page === "pagetwo") {
        stepPercentage = 50;
    } else if (page === "pagethree") {
        stepPercentage = 100;
    }
    return (
        <React.Fragment>
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Post Tasks </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Post Tasks</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ProgressBar percent={stepPercentage}>
                <Step>
                    {({ accomplished, index }) => (
                        <div
                            className={`indexedStep ${accomplished ? "accomplished" : null}`}
                            onClick={() => onPageNumberClick("1")}
                        >

                            {index + 1}
                        </div>

                    )}
                </Step>
                <Step>
                    {({ accomplished, index }) => (
                        <div
                            className={`indexedStep ${accomplished ? "accomplished" : null}`}
                        // onClick={() => onPageNumberClick("2")}
                        >
                            {index + 1}
                        </div>
                    )}
                </Step>
                <Step>
                    {({ accomplished, index }) => (
                        <div
                            className={`indexedStep ${accomplished ? "accomplished" : null}`}
                        // onClick={() => onPageNumberClick("3")}
                        >
                            {index + 1}
                        </div>
                    )}
                </Step>
            </ProgressBar>
        </React.Fragment>
    )
}

export default PostTask;